<template>
  <div class="pb-8" data-type="spark">
    <div class="p-10 bg-gray-50 rounded-lg flex flex-col gap-5 min-h-[51vh]">
      <div class="text-center w-fit mx-auto flex items-center gap-3 mb-2">
        <img :src="SparkIcon" alt="Spark icon" class="w-14 h-14">
        <h1>{{ t('slides_editor.components.spark_preview.spark') }}</h1>
      </div>
      <div class="w-3/4 mx-auto text-center text-2xl font-normal text-gray-700">
        <p>
          {{ t('slides_editor.components.spark_preview.description') }}
        </p>
        <p>
          <a target="_blank" href="https://help.wellioeducation.com/interactive-questions-in-wellio#Sparks">
            {{ t('slides_editor.components.spark_preview.help_link_text') }}
          </a>
        </p>
      </div>
      <div class="px-6 rounded-lg">
        <p class="text-gray-500 text-sm mb-2">{{ t('slides_editor.components.spark_preview.questions_header') }}</p>
        <div
          class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 justify-center relative"
          data-questions
          ref="questionsContainer"
        >
          <SparkQuestion
            v-for="(question) in block.section.spark?.questions"
            :key="question.id"
            :question="question"
            :selected="selectedQuestion === question.id"
            @select="selectedQuestion = question.id"
            :block="block"
          />
        </div>
      </div>
    </div>
    </div>
</template>

<script setup>
  import { useBlockUpdate } from '@/features/slides_editor/composables'
  import { ref, onMounted } from 'vue'
  import Sortable from "sortablejs"
  import SparkQuestion from './sparks/SparkQuestion.vue'
  import SparkIcon from '../../../../../../assets/images/spark.svg'
  import { t } from '@/libs/i18n'

  const props = defineProps({
    block: {
      type: Object,
      required: true
    },
    isThumbnail: {
      type: Boolean,
      default: false
    }
  })

  const { onBlockUpdate } = useBlockUpdate(props.block, { showErrorStatus: false })

  const selectedQuestion = ref(null)
  const questionsContainer = ref(null)


  onMounted(() => {
    new Sortable(questionsContainer.value, {
      animation: 150,
      forceFallback: true,
      onEnd: ({ oldIndex, newIndex }) => {
        const questions = props.block.section.spark.questions
        const question = questions[oldIndex]

        questions.splice(oldIndex, 1)
        questions.splice(newIndex, 0, question)

        props.block.section.spark.questions = questions.map((question, index) => ({
          ...question,
          position: index + 1
        }))

        const sectionParams = {
          id: props.block.section.id,
          section_spark_attributes: {
            id: props.block.section.spark.section_spark_id,
            spark_attributes: {
              id: props.block.section.spark.id,
              questions_attributes: props.block.section.spark.questions
            }
          }
        }

        onBlockUpdate(sectionParams, 'section_attributes')
      },
    })
  })
</script>

<style scoped>
  @reference "@/../assets/stylesheets/application.tailwind.css";

  .reveal h1 {
    @apply text-gray-900 text-7xl font-bold capitalize font-semibold font-heading;
  }

  .reveal a {
    @apply !text-indigo-600;
  }

  .reveal p:first-child {
    @apply mt-0;
  }

  .reveal p:last-child {
    @apply mb-6;
  }

</style>